import React from 'react'
import TextField from 'material-ui/TextField';
import { cyan500 } from 'material-ui/styles/colors';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import SelectField from 'material-ui/SelectField';

class Discount extends React.Component {
render(){
  const { disableFields, isTrue, styles, handleDiscountTypeChange, discountType, discountProducts, discountItems, discount, handleChange,  errorText, discountItemsSelect, discountProductsSelect } = this.props;
  return(
    <div>
      <h2>Discount</h2>
        <div className="content">
          <SelectField
            value={discountType || ''}
            onChange={!disableFields?
              (event, index, value) => handleDiscountTypeChange(event, index, value)
            :''}
            floatingLabelText="Discount Type"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountType"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={errorText.discountType}
            errorStyle={{ color: cyan500 }}
          >
            <MenuItem value="Value Off Order" key={1} primaryText="Value Off Order" />
            <MenuItem value="Percent Off Order" key={2} primaryText="Percent Off Order" />
            <MenuItem value="Value Off Product" key={3} primaryText="Value Off Product" />
            <MenuItem value="Percent Off Product" key={4} primaryText="Percent Off Product" />
            <MenuItem value="Value Off Item" key={5} primaryText="Value Off Item" />
            <MenuItem value="Percent Off Item" key={6} primaryText="Percent Off Item" />
            <MenuItem value="Flat Rate Shipping" key={7} primaryText="Flat Rate Shipping" />
            <MenuItem value="Percent Off Shipping" key={8} primaryText="Percent Off Shipping" />
          </SelectField>
          <TextField
            floatingLabelText="Discount Value/Flat Rate"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={discount.discountValue || 0}
            name="discountValue"
            onChange={!disableFields? handleChange : ''}
            style={styles.inputStyle}
            errorText={errorText.discountValue}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Discount Percent"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={discount.discountPercent || 0}
            name="discountPercent"
            onChange={!disableFields? handleChange : ''}
            style={styles.inputStyle}
            errorText={errorText.discountPercent}
            errorStyle={{ color: cyan500 }}
          />
          <br />
          <SelectField
            value={discountProducts || []}
            multiple={isTrue}
            onChange={!disableFields?
              (event, index, value) => handleSelectChange(event, index, value, 'discountProducts')
            : ''}
            floatingLabelText="Discount Products"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountProducts"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={errorText.discountProducts}
            errorStyle={{ color: cyan500 }}
          >
            {discountProductsSelect}
          </SelectField>
          <SelectField
            value={discountItems || []}
            multiple={isTrue}
            onChange={!disableFields?
              (event, index, value) => handleSelectChange(event, index, value, 'discountItems')
            : ''}
            floatingLabelText="Discount Items"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountItems"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={errorText.discountItems}
            errorStyle={{ color: cyan500 }}
          >
            {discountItemsSelect}
          </SelectField>
          <TextField
            floatingLabelText="Discount Limit Quantity"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={discount.discountLimitQty || 0}
            name="discountLimitQty"
            onChange={!disableFields? handleChange : ''}
            style={styles.inputStyle}
          />
        </div>
      </div>
  )
}
}

export default (Discount);


// WEBPACK FOOTER //
// ./src/components/discounts/common/Discount.js